import {
  Box,
  Grid,
  Typography,
  Link,
  Paper,
  Button,
  Container,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import CustomNumberField from "src/components/uiElements/form/customNumberField";
import CustomPasswordField from "src/components/uiElements/form/customPasswordField";
import { CustomPrimaryButtonFixed } from "src/components/uiElements/buttons/primaryButtonFixed";
import UseSignIn from "src/screens/outerScreens/signin/useSignIn";
import ForgotPasswordScreen from "../forgot_password/forgotPasswordScreen";
import SignUpScreen from "../signup/signUpScreen";
import { TwoFAModal } from "src/components/modal/TwoFAModel";
import CustomCheckBox from "src/components/uiElements/buttons/customCheckBox";
import GoogleIcon from "@mui/icons-material/Google";
import PasswordResetSuccessScreen from "../password_reset_success/passwordResetSuccessScreen";
import { GoogleLogin } from "@react-oauth/google";
import { ToastError, ToastSuccess } from "src/components/uiElements/toast";
import { GoogleLogin as GOOGLE_LOGIN } from "src/components/api/signin_social_media/signInWithSocialMedia";
import { nextLocalStorage } from "src/components/api/helper/apiHelper";
import { jwtDecode } from "jwt-decode";
import { useDispatch } from "react-redux";
import { login } from "src/store/authSlice";
import { useLocation, useNavigate } from "react-router-dom";

const theme = createTheme();
interface SignInScreenProps {
  onSignInSuccess?: () => void;
}

const SignInScreen: React.FC<SignInScreenProps> = ({ onSignInSuccess }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
const location = useLocation();
  const returnUrl = location.state?.returnUrl;
  const {
    loading,
    setLoading,
    onSubmit,
    formContext,
    rememberMe,
    setRememberMe,
    isPasswordResetSuccessOpen,
    setIsPasswordResetSuccessOpen,
  } = UseSignIn(onSignInSuccess, returnUrl);
  const [UserName, setUserName] = useState("");
  const [Password, setPassword] = useState("");
  const [isEnterPressed, setIsEnterPressed] = useState(false);

  const handleSignUpClick = () => {
    navigate("/sign_up");
  };

  const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      event.preventDefault();
      setIsEnterPressed(true);
      // Reset the hover effect after a short delay
      setTimeout(() => setIsEnterPressed(false), 300);
      handleSubmit(onSubmit)();
    }
  };

  const { handleSubmit } = formContext;

  const [isSignUpOpen, setIsSignUpOpen] = useState(false);
  const [isSignInOpen, setIsSignInOpen] = useState(true);
  const [isForgotPasswordOpen, setIsForgotPasswordOpen] = useState(false);

  useEffect(() => {
    setIsSignInOpen(true);
    setIsSignUpOpen(false);
    setIsForgotPasswordOpen(false);
  }, []);

  useEffect(() => {
    const savedRememberMe = window.localStorage.getItem("RememberMe");
    if (savedRememberMe) {
      setRememberMe(true);
      setUserName(window.localStorage.getItem("UserName") || "");
      setPassword(window.localStorage.getItem("Password") || "");
    }
  }, [setRememberMe]);

  const handleSignUpOpen = () => {
    setIsSignUpOpen(true);
    setIsSignInOpen(false);
  };

  const handleForgotPasswordOpen = () => {
    setIsForgotPasswordOpen(true);
    setIsSignInOpen(false);
  };
  return (
    <>
      <ThemeProvider theme={theme}></ThemeProvider>
      {/* <Box sx={{ background:'url(./rocket.jpg) no-repeat', backgroundSize:'cover',  }}></Box> */}
      {isSignInOpen && (
        <FormProvider {...formContext}>
          <form
            onSubmit={handleSubmit(onSubmit)}
            noValidate
            style={{ width: "100%", padding: "30px" }}
          >
            <Box>
              <Grid
                container
                spacing={0}
                direction="column"
                alignItems="end"
                justifyContent="end"
                sx={{ marginTop: "15px" }}
              >
                <Grid item xs={3}>
                  <Box>
                    <Box>
                      <Box sx={{ textAlign: "left" }}>
                        <img
                          src="/logo_b.png"
                          width={"170"}
                          style={{ display: "inline" }}
                        />
                      </Box>

                      <Typography
                        variant="h5"
                        sx={{
                          color: "#000000",
                          textTransform: "titlecase",
                          fontWeight: "600",
                          fontSize: "24px",
                          textAlign: "left",
                          marginTop: "20px",
                          marginBottom: "0px",
                        }}
                      >
                        Sign In
                      </Typography>
                      <Typography
                        variant="h5"
                        sx={{
                          fontSize: "16px",
                          fontWeight: "300",
                          color: "#000000",
                          textAlign: "left",
                          marginBottom: "20px",
                        }}
                      >
                        Enter your details to sign in
                      </Typography>

                      <Grid
                        container
                        spacing={1}
                        sx={{
                          justifyContent: "center",
                        }}
                      >
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                          <CustomNumberField
                            required
                            name={"UserName"}
                            size="small"
                            label={"UserName"}
                            placeholder="Ex. 9800000000"
                            length={10}
                            onChange={(e) => setUserName(e.target.value)}
                            onKeyPress={handleKeyPress}
                          />
                        </Grid>

                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                          <CustomPasswordField
                            required
                            autoComplete={"new-password"}
                            label={"Password"}
                            name={"Password"}
                            length={50}
                            placeholder="Password"
                            size="small"
                            onChange={(e) => setPassword(e.target.value)}
                            onKeyPress={handleKeyPress}
                          />
                        </Grid>

                        <Grid item xs={12} sx={{ textAlign: "end", pt: 0 }}>
                          <Typography>
                            <Link
                              onClick={handleForgotPasswordOpen}
                              sx={{
                                textDecoration: "none",
                                fontSize: "14px",
                                color: "#797979",
                                fontWeight: 300,
                                cursor: "pointer",
                                "&:hover": {
                                  color: "#6A0DAD",
                                },
                              }}
                            >
                              <span style={{ textDecoration: "underline" }}>
                                Forgot Password?
                              </span>
                            </Link>
                          </Typography>
                          <Typography sx={{ marginTop: "-5px" }}>
                            <CustomCheckBox
                              label="Remember Me"
                              onChange={(checked) => setRememberMe(checked)}
                              checked={rememberMe}
                            />
                          </Typography>
                        </Grid>

                        <Grid
                          item
                          xs={12}
                          style={{
                            alignItems: "center",
                            display: "grid",
                          }}
                          sx={{ mt: "14px" }}
                        >
                          <CustomPrimaryButtonFixed
                            style={{
                              fontSize: "20px",
                              fontWeight: 600,
                              justifySelf: "center",
                              width: "100%",
                            }}
                            title="Sign In"
                            loading={loading}
                            forceHover={isEnterPressed}
                          />
                        </Grid>

                        <Grid item xs={12}>
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              width: "100%",
                              marginTop: "10px",
                            }}
                          >
                            <Box
                              sx={{
                                flex: 1,
                                height: "1px",
                                backgroundColor: "#989898",
                              }}
                            />

                            <Typography
                              variant="h6"
                              sx={{
                                mx: 3,
                                fontWeight: 300,
                                textTransform: "titlecase",
                                fontSize: "16px",
                                color: "#000000",
                              }}
                            >
                              or Sign In with
                            </Typography>

                            <Box
                              sx={{
                                flex: 1,
                                height: "1px",
                                backgroundColor: "#989898",
                              }}
                            />
                          </Box>
                        </Grid>

                        <Grid item xs={12}>
                          <GoogleLogin
                            shape="pill"
                            onSuccess={async (credentialResponse) => {
                              const token = credentialResponse.credential;
                              if (!token) return;

                              type GoogleUser = {
                                name: string;
                                email: string;
                                picture: string;
                                sub: string;
                              };

                              const userData = jwtDecode<GoogleUser>(token);

                              let inputObj = {
                                name: userData.name,
                                email: userData.email,
                                profileImage: userData.picture,
                                googleId: userData.sub,
                                provider: "google",
                              };

                              let request = JSON.stringify(inputObj);

                              setLoading(true);

                              const response = await GOOGLE_LOGIN(request);

                              setLoading(false);
                              if (!response?.status) {
                                let failResult = JSON.parse(response?.data!);

                                ToastError(failResult.Message);
                                return;
                              }
                              let result = JSON.parse(response?.data!);
                              localStorage.setItem("UserID", String(result.UserID));
                              sessionStorage.setItem("UserID", String(result.UserID));
                              if (result.Token) {
                                sessionStorage.setItem("Token", result.Token);
                                sessionStorage.setItem("UserTypeID", result.UserTypeID);
                                sessionStorage.setItem("UserID", result.UserID);
                              }
                              ToastSuccess(result.Message);
                              nextLocalStorage()?.setItem("SignInUser", "True");
                              onSignInSuccess?.();
                              if (!onSignInSuccess) {
                                navigate("/home");
                              }
                            }}
                          />

                          {/* <Button
                                variant="outlined"
                                fullWidth
                                startIcon={<img src="/google_icon.svg" width={20} />}
                                sx={{
                                  textTransform: "none",
                                  borderRadius: "50px",
                                  marginTop: "10px",
                                  py: 1.3,
                                  border: "1px solid #dadce0",
                                  color: "#000000",
                                  backgroundColor: "#fff",
                                  fontSize: "14px",
                                  fontWeight: 500,
                                  "&:hover": {
                                    backgroundColor: "#f7f8f8",
                                    borderColor: "#6A0DAD",
                                    color: "#6A0DAD",
                                  },
                                }}
                              >
                                Sign in with Google
                              </Button> */}
                        </Grid>

                        <Grid
                          item
                          xs={12}
                          sx={{
                            fontWeight: 300,
                            fontSize: "14px",
                            textAlign: "center",
                            marginTop: "10px",
                            color: "#000000",
                          }}
                        >
                          Don't have an account?
                          <Link
                            onClick={handleSignUpOpen}
                            sx={{
                              textDecoration: "none",
                              fontSize: "14px",
                              color: "#6A0DAD",
                              marginLeft: "5px",
                              fontWeight: 400,
                              cursor: "pointer",
                              "&:hover": {
                                color: "#000000",
                              },
                            }}
                          >
                            <span style={{ textDecoration: "underline" }}>
                              Sign Up
                            </span>
                          </Link>
                        </Grid>
                      </Grid>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </form>
        </FormProvider>
      )}
      {isSignUpOpen && <SignUpScreen />}
      {isForgotPasswordOpen && <ForgotPasswordScreen />}
      {isPasswordResetSuccessOpen && <PasswordResetSuccessScreen />}
    </>
  );
};

export default SignInScreen;
